"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageWrapper = exports.IconWrapper = void 0;
const flora_react_1 = require("@grupoboticario/flora-react");
exports.IconWrapper = (0, flora_react_1.styled)('div', {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    svg: {
        margin: '0 auto',
        color: '$nonInteractiveAuxiliar',
        fontSize: '$40',
    },
    variants: {
        smallDefaultIcon: {
            true: {
                svg: {
                    fontSize: '$20',
                },
            },
        },
    },
});
exports.ImageWrapper = (0, flora_react_1.styled)('div', {
    img: {
        backgroundColor: '$backgroundPrimary',
        width: '100%',
    },
});
